import { jsx as _jsx } from "react/jsx-runtime";
import { SpaceMemberList } from './SpaceMemberList';
export const WhySpaceMemberList = ({ space, spaceId, }) => {
    return _jsx(SpaceMemberList, { spaceId: spaceId || (space === null || space === void 0 ? void 0 : space.id) }, "members-list");
};
//# sourceMappingURL=WhySpaceMemberList.js.map